import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink } from '@apollo/client'
import { ReactElement } from 'react'
import fetch from 'cross-fetch'

const SERVER_URL =
    process.env.NODE_ENV === 'test'
        ? 'http://localhost/api/graphql'
        : process.env.REACT_APP_MP_GRAPHQL_SERVER_URL ?? '/api/mfeedback/graphql'

export const client = new ApolloClient({
    link: new HttpLink({
        uri: SERVER_URL,
        fetch,
        credentials: 'include',
    }),
    cache: new InMemoryCache(),
})

interface ChildrenProps {
    children: ReactElement
}

export function GraphQlProvider({ children }: ChildrenProps) {
    return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export function withGraphql<T>(Component: any) {
    return (props: T) => (
        <GraphQlProvider>
            <Component {...props} />
        </GraphQlProvider>
    )
}
